const WebPage = [
  {
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "physics",
  "name": "2026 Physics Weightage",
  "link": "physics-weightage-2026"
},
  {
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "chemistry",
  "name": "2026 Physics Weightage",
  "link": "chemistry-weightage-2026"
},
{
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "biology",
  "name": "2026 Biology Weightage",
  "link": "biology-weightage-2026"
},

  {
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "physics",
  "name": "2025 Physics Weightage",
  "link": "physics-weightage-2025"
},
  {
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "chemistry",
  "name": "2025 Physics Weightage",
  "link": "chemistry-weightage-2025"
},
{
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "biology",
  "name": "2025 Biology Weightage",
  "link": "biology-weightage-2025"
},

{
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "biology",
  "name": "2020 to 2024 Biology Weightage",
  "link": "biology-weightage-2020-24"
},
{
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "chemistry",
  "name": "2020 to 2024 Chemistry Weightage",
  "link": "chemistry-weightage2020-24"
},
{
   "id": "",
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "physics",
  "name": "2020 to 2024 Physics Weightage",
  "link": "physics-weightage-2020-24"
}] 



export default WebPage;